<template>
	<div
		class="flex flex-col items-center lg:flex-row"
		:class="[horizontalLineGap]"
	>
		<component
			:is="'h' + size"
			class="w-full lg:w-auto"
			:class="[
				textColor,
				headingFontWeight,
				headingMargin,
				headingCenter ? 'text-center' : '',
			]"
		>
			<slot>Heading</slot>
		</component>

		<hr
			v-if="horizontalLine"
			class="w-full flex-1"
			:class="[horizontalLineClass]"
		/>
	</div>
</template>

<script setup>
const props = defineProps({
	horizontalLine: {
		type: Boolean,
		default: false,
		required: false,
	},
	horizontalLineClass: {
		type: String,
		default: '',
		required: false,
	},
	horizontalLineGap: {
		type: String,
		default: 'gap-x-10',
		required: false,
	},
	size: {
		type: Number,
		default: 1,
		required: false,
		validator: (value) => [1, 2, 3, 4, 5].includes(value),
	},
	textColor: {
		type: String,
		default: '',
		required: false,
	},
	headingFontWeight: {
		type: String,
		default: '',
		required: false,
	},
	headingMargin: {
		type: String,
		default: '',
		required: false,
	},
	headingCenter: {
		type: Boolean,
		default: false,
		required: false,
	},
})
</script>
